import { invalidateKB } from '@/services/invalidateKB';
import { trpc } from '@/services/trpc';

export function useDocumentMutation() {
  const createDocument = trpc.documents.create.useMutation({
    onSuccess: invalidateKB,
  });

  const createExternalDocument =
    trpc.documents.createExternalDocument.useMutation({
      onSuccess: invalidateKB,
    });

  const update = trpc.documents.update.useMutation({
    onSuccess: invalidateKB,
  });

  const refresh = trpc.documents.refresh.useMutation({
    onSuccess: invalidateKB,
  });

  const resetEmbedding = trpc.documents.resetEmbedding.useMutation({
    onSuccess: invalidateKB,
  });

  const resetAllEmbeddings = trpc.documents.resetAllEmbeddings.useMutation({
    onSuccess: invalidateKB,
  });

  const refreshAll = trpc.documents.refreshAll.useMutation({
    onSuccess: invalidateKB,
  });

  const remove = trpc.documents.deleteFromChat.useMutation({
    onSuccess: invalidateKB,
  });

  const updateAgentAccess = trpc.documents.updateDocumentAgents.useMutation({
    onSuccess: invalidateKB,
  });

  const updateAutoUpdate = trpc.documents.updateAutoUpdate.useMutation({
    onSuccess: invalidateKB,
  });

  const checkDocumentUpdatesNow =
    trpc.documents.checkDocumentUpdatesNow.useMutation({
      onSuccess: invalidateKB,
    });

  const refreshAllByOrg = trpc.documents.refreshAllByOrg.useMutation({
    onSuccess: invalidateKB,
  });

  const resetAllEmbeddingsByOrg =
    trpc.documents.resetAllEmbeddingsByOrg.useMutation({
      onSuccess: invalidateKB,
    });

  return {
    createDocument,
    createExternalDocument,
    update,
    remove,
    refresh,
    refreshAll,
    resetEmbedding,
    resetAllEmbeddings,
    updateAgentAccess,
    updateAutoUpdate,
    checkDocumentUpdatesNow,
    refreshAllByOrg,
    resetAllEmbeddingsByOrg,
  };
}
